import type { FC } from "react";
import React from "react";
import { Box } from "@edreamsodigeo/prisma-design-system";
import { useTranslation, createFeature } from "@edreamsodigeo/frontend-core";

import { AutoRenewalDeactivationCondition } from "~/generated/graphql";
import type { MembershipWithInstallmentsDisclaimerProps } from "./contract";
import { EQUAL_PROMINENCE_MOBILE } from "~/clientState/ab/teams/primo";

const MembershipWithInstallmentsDisclaimerBody: FC<
  MembershipWithInstallmentsDisclaimerProps
> = ({ autoRenewalPolicy }): JSX.Element | null => {
  const { t } = useTranslation();
  const disclaimersMap = {
    [AutoRenewalDeactivationCondition.DeactivationAllowedAfter_12ConsecutiveMonthlyRenewals]:
      "membershipWithInstallmentsDisclaimer.yearlyPaidMonthly",
  };
  if (!autoRenewalPolicy) return null;
  return <>{t(`${disclaimersMap[autoRenewalPolicy]}`)}</>;
};

const MembershipWithInstallmentsDisclaimerBlock: FC<
  MembershipWithInstallmentsDisclaimerProps
> = ({ autoRenewalPolicy }) => {
  return (
    <MembershipWithInstallmentsDisclaimerBody
      autoRenewalPolicy={autoRenewalPolicy}
    />
  );
};

const MembershipWithInstallmentsDisclaimerInline: FC<
  MembershipWithInstallmentsDisclaimerProps
> = ({ autoRenewalPolicy }) => {
  return (
    <Box
      display={"inline"}
      data-testid={"MembershipWithInstallmentsDisclaimerInline"}
    >
      <MembershipWithInstallmentsDisclaimerBody
        autoRenewalPolicy={autoRenewalPolicy}
      />
    </Box>
  );
};

const MembershipWithInstallmentsDisclaimer = createFeature({
  name: EQUAL_PROMINENCE_MOBILE,
  variations: [
    MembershipWithInstallmentsDisclaimerBlock,
    MembershipWithInstallmentsDisclaimerBlock,
    MembershipWithInstallmentsDisclaimerBlock,
    MembershipWithInstallmentsDisclaimerInline,
  ],
  version: 1,
});

export default MembershipWithInstallmentsDisclaimer;
